module.exports = __webpack_public_path__ + "svg/zoomin.fe9585ba2d2115da3d01185249da6e13.svg";